import PaletteIcon from '@mui/icons-material/Palette';
import { PERMISSIONS } from '../../constants';
import { UserRole } from '../../models';
import ComponentWithPermissions from '../ComponentWithPermissions';
import list from './AppArtList';
import edit from './AppArtEdit';

export default {
  list,
  edit: new ComponentWithPermissions({
    component: edit,
    permissions: [PERMISSIONS.ADMIN],
    userRoles: [UserRole.admin],
  }),
  name: 'app-art',
  permissions: [PERMISSIONS.ADMIN],
  options: { label: 'Imagens' },
  icon: PaletteIcon,
};
